import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/components/AuthContext";

export const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="grid min-h-screen place-items-center bg-brand-navy text-white" data-testid="staff-auth-loading">
        <Loader2 className="h-8 w-8 animate-spin text-brand-copper" />
      </div>
    );
  }

  if (!user) return <Navigate to="/staff/login" replace />;
  return children;
};
